// src/pages/AdminAuthorList.js

import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs, addDoc, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import './AdminModals.css'; // Reutilizando o mesmo CSS do modal

const AdminAuthorList = () => {
    const [authors, setAuthors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Estados para o modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentAuthor, setCurrentAuthor] = useState(null);
    const [formData, setFormData] = useState({ nomeCompleto: '', funcao: '' });

    useEffect(() => {
        fetchAuthors();
    }, []);

    const fetchAuthors = async () => {
        try {
            setLoading(true);
            const authorsCollectionRef = collection(db, 'autores');
            const data = await getDocs(authorsCollectionRef);
            const authorsData = data.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAuthors(authorsData);
            setError(null);
        } catch (err) {
            console.error("Erro ao buscar autores:", err);
            setError("Falha ao carregar os autores.");
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (author = null) => {
        setCurrentAuthor(author);
        setFormData(author ? { nomeCompleto: author.nomeCompleto, funcao: author.funcao } : { nomeCompleto: '', funcao: '' });
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCurrentAuthor(null);
        setFormData({ nomeCompleto: '', funcao: '' });
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveAuthor = async (e) => {
        e.preventDefault();
        if (!formData.nomeCompleto || !formData.funcao) {
            alert("Por favor, preencha todos os campos.");
            return;
        }

        try {
            if (currentAuthor) {
                const authorDoc = doc(db, 'autores', currentAuthor.id);
                await updateDoc(authorDoc, formData);
            } else {
                await addDoc(collection(db, 'autores'), formData);
            }
            fetchAuthors();
            handleCloseModal();
        } catch (err) {
            console.error("Erro ao salvar autor:", err);
            alert("Ocorreu um erro ao salvar o autor.");
        }
    };

    const handleDeleteAuthor = async (id) => {
        if (window.confirm("Tem certeza que deseja apagar este autor?")) {
            try {
                const authorDoc = doc(db, 'autores', id);
                await deleteDoc(authorDoc);
                fetchAuthors();
            } catch (err) {
                console.error("Erro ao apagar autor:", err);
                alert("Ocorreu um erro ao apagar o autor.");
            }
        }
    };

    if (loading) return <div className="loading-message">A carregar autores...</div>;
    if (error) return <div className="error-message">{error}</div>;

    return (
        <div className="admin-list-container">
            <div className="admin-list-header">
                <h1>Gerenciamento de Autores</h1>
                <button onClick={() => handleOpenModal()} className="create-button">
                    Adicionar novo autor
                </button>
            </div>

            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Nome Completo</th>
                            <th>Função</th>
                            <th style={{ textAlign: 'right' }}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {authors.map(author => (
                            <tr key={author.id}>
                                <td>{author.nomeCompleto}</td>
                                <td>{author.funcao}</td>
                                <td className="actions-cell">
                                    <button onClick={() => handleOpenModal(author)} className="action-button edit-button">Editar</button>
                                    <button onClick={() => handleDeleteAuthor(author.id)} className="action-button delete-button">Apagar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>{currentAuthor ? 'Editar Autor' : 'Novo Autor'}</h2>
                        <form onSubmit={handleSaveAuthor}>
                            <div className="form-group">
                                <label htmlFor="nomeCompleto">Nome Completo</label>
                                <input type="text" id="nomeCompleto" name="nomeCompleto" value={formData.nomeCompleto} onChange={handleFormChange} required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="funcao">Função</label>
                                <input type="text" id="funcao" name="funcao" value={formData.funcao} onChange={handleFormChange} placeholder="Ex: Proprietário, Escritor" required />
                            </div>
                            <div className="modal-actions">
                                <button type="button" onClick={handleCloseModal} className="button-cancel">Cancelar</button>
                                <button type="submit" className="button-save">Salvar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminAuthorList;
